import FormPageFake, {
  THEMES as FAKE_THEMES,
} from '@/components/fakes/formPagesFake';
import { FORM_TEMPLATE_THEMES } from '@/components/fakes/formTemplateFake';

function FormMiMovistarFake() {
  return (
    <FormPageFake
      formTemplateFakes={[
        {
          fakeLength: 1,
          formTemplateTheme: FORM_TEMPLATE_THEMES.LONG,
        },
        {
          theme: FAKE_THEMES.textList,
          fakeLength: 1,
        },
        {
          theme: FAKE_THEMES.textList,
          fakeLength: 2,
        },
      ]}
    />
  );
}
export default FormMiMovistarFake;
